export default "__VITE_ASSET__eDb0XJbP__"